import { render, staticRenderFns } from "./ListaInsumos.vue?vue&type=template&id=4bcccd2c"
import script from "./ListaInsumos.vue?vue&type=script&lang=js"
export * from "./ListaInsumos.vue?vue&type=script&lang=js"
import style0 from "./ListaInsumos.vue?vue&type=style&index=0&id=4bcccd2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports